export default __webpack_public_path__ + "static/media/not-without-you.1c3cd886.webp";